import { DateOnly } from '@if/core/date'
import { EFinancingCompany, EMerchantType, MerchantBase } from '@if/core/types'
import { MerchantPaymentPlan } from './MerchantPaymentPlan'

export enum EReportGenerationFrequency {
  None = 'none',
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
}

export interface Merchant extends MerchantBase {
  merchantTypeId: EMerchantType
  paymentPlans: MerchantPaymentPlan[]
  financingCompanyId: EFinancingCompany
  canSkipFlinks: boolean
  insuranceProviderIds: string[]
  warrantyProviderIds: string[]
  firstOnboardedOn: DateOnly
  showInterestRateOnMerchantDashboard: boolean
  reportGenerationFrequency: EReportGenerationFrequency
  reportRecipientsEmailList: string[]
}
